var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 3.15474C8.5 2.73792 8.86871 2.40002 9.32353 2.40002H14.6765C15.1313 2.40002 15.5 2.73792 15.5 3.15474V5.64531C15.5 6.06213 15.1313 6.40002 14.6765 6.40002C14.2216 6.40002 13.8529 6.06213 13.8529 5.64531V3.90946H10.1471V5.64531C10.1471 6.06213 9.77835 6.40002 9.32353 6.40002C8.86871 6.40002 8.5 6.06213 8.5 5.64531V3.15474Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 6.65002C4.5 5.95967 5.10269 5.40002 5.84615 5.40002H18.1538C18.8973 5.40002 19.5 5.95967 19.5 6.65002C19.5 7.34038 18.8973 7.90002 18.1538 7.90002H5.84615C5.10269 7.90002 4.5 7.34038 4.5 6.65002Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92188 9.40002C7.70715 9.40002 8.34375 10.0396 8.34375 10.8286V18.5429H15.6562V10.8286C15.6562 10.0396 16.2928 9.40002 17.0781 9.40002C17.8634 9.40002 18.5 10.0396 18.5 10.8286V19.1551C18.5 20.3949 17.4996 21.4 16.2656 21.4H7.73438C6.50037 21.4 5.5 20.395 5.5 19.1551V10.8286C5.5 10.0396 6.1366 9.40002 6.92188 9.40002Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.6e4d7e9e7678062acfd08a7c61cd8435.svg";
export { ForwardRef as ReactComponent };